/* eslint-disable import/no-duplicates */
import { useConnector } from 'react-instantsearch'
import type {
  RangeConnectorParams,
  RangeWidgetDescription,
} from 'instantsearch.js/es/connectors/range/connectRange'
import connectRange from 'instantsearch.js/es/connectors/range/connectRange'

export type UseRangeSliderProps = RangeConnectorParams

export function useRangeSlider(props?: UseRangeSliderProps) {
  return useConnector<RangeConnectorParams, RangeWidgetDescription>(
    connectRange,
    props,
  )
}
